import React from 'react';

function RopeAccess() {
  const ropeAccessProjects = [
    {
      title: "Bridge Inspection",
      description: "Conducted a detailed inspection of a 100-meter suspension bridge using rope access techniques. Identified and documented structural issues for maintenance planning.",
      imageUrl: "ropeaccess.jpg"
    },
    {
      title: "Wind Turbine Maintenance",
      description: "Performed routine maintenance and repairs on offshore wind turbines. Work included blade inspections, gear oil changes, and electrical system checks.",
      imageUrl: "kneebar.jpg"
    },
    {
      title: "High-Rise Window Cleaning",
      description: "Led a team of rope access technicians in cleaning windows on a 50-story skyscraper. Implemented new safety protocols that increased efficiency by 20%.",
      imageUrl: "outdoorinstructor.jpg"
    }
  ];

  return (
    <div className="rope-access">
      <h1>Rope Access Projects</h1>
      <p>As a certified rope access technician, I've worked on various challenging projects. Here are some highlights:</p>
      
      <div className="rope-access-projects">
        {ropeAccessProjects.map((project, index) => (
          <div key={index} className="project-card">
            <h3>{project.title}</h3>
            <div className="image-placeholder" style={{backgroundImage: `url(${project.imageUrl})`}}></div>
            <p>{project.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default RopeAccess;